import styled, { CSSObject } from 'styled-components'

export interface TooltipMessageUiProps {
  maxWidth?: number
  isVisible?: boolean
  top?: number
  left?: number
  styles?: CSSObject
}

export const TooltipMessageUi = styled.div<TooltipMessageUiProps>`
  min-width: 100px;
  max-width: ${p => (p.maxWidth ? `${p.maxWidth}px` : '350px')};
  white-space: pre-line;
  position: fixed;
  z-index: 11; // more than TooltipOverlayUi
  padding: 8px 12px;
  top: ${p => (p.top ? `${p.top}px` : 'auto')};
  left: ${p => (p.left ? `${p.left}px` : 'auto')};
  background: white;
  text-transform: none;
  opacity: ${p => (p.isVisible ? 1 : 0)};
  visibility: ${p => (p.isVisible ? 'visible' : 'hidden')};
  border-radius: 6px;
  border: 1px solid #D7D8DA;
  line-height: 16px;
  font-size: 12px;
  font-weight: 400;
  transition: opacity 0.2s ease;
  ${p => p.styles && p.styles}
`
